import { useEffect, useState } from "react";
import { Switch } from "@/components/ui/switch";
import StepShell from "../StepShell";
import { useServiceMenuOptions } from "../useBriefing";

/**
 * Menu de serviços jurídicos — quais opções oferecer no WhatsApp para clientes
 * já existentes (consultar processo, audiências, financeiro, etc.). As opções
 * disponíveis dependem do provedor conectado no Bloco J. Entram no fluxo gerado.
 */
export default function BlocoMenuServicos({ briefing, autosave }) {
  const provider = briefing.juridicalProvider;
  const { data, isLoading } = useServiceMenuOptions(provider);
  const options = data?.options || [];

  const [menu, setMenu] = useState(briefing.serviceMenu || {});

  // Default every available option to ON the first time (no saved menu yet).
  useEffect(() => {
    if (!briefing.serviceMenu && options.length > 0) {
      const defaults = {};
      for (const o of options) defaults[o.id] = true;
      setMenu(defaults);
      autosave({ serviceMenu: defaults });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.length]);

  function toggle(id, value) {
    const next = { ...menu, [id]: value };
    setMenu(next);
    autosave({ serviceMenu: next });
  }

  if (!provider || provider === "none") {
    return (
      <StepShell title="Menu de serviços no WhatsApp">
        <p className="text-sm text-muted-foreground">
          Este menu depende de um sistema jurídico conectado. Como você escolheu
          “Não uso” no primeiro passo, a IA fará apenas a triagem de novos leads.
        </p>
      </StepShell>
    );
  }

  return (
    <StepShell
      title="Menu de serviços no WhatsApp"
      description="Para clientes já cadastrados, o assistente oferece estas opções automaticamente. Desligue as que não quiser."
    >
      {isLoading ? (
        <p className="text-sm text-muted-foreground">Carregando opções…</p>
      ) : (
        <div className="divide-y divide-border/60 rounded-2xl border border-border bg-surface-inset/40">
          {options.map((o) => (
            <label
              key={o.id}
              className="flex cursor-pointer items-center justify-between gap-4 p-4"
            >
              <span className="text-sm font-medium text-foreground">{o.label}</span>
              <Switch
                checked={menu[o.id] !== false}
                onCheckedChange={(v) => toggle(o.id, v)}
                disabled={o.always}
              />
            </label>
          ))}
        </div>
      )}
      <p className="mt-3 text-xs text-muted-foreground">
        “Identificar cliente” e “Falar com atendimento” são sempre incluídos.
      </p>
    </StepShell>
  );
}
